import React from 'react';
const links = ['Impressum', 'Datenschutz', 'Rückgaberecht', 'Kontakt'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-95" data-mp="3ggarlxr3gh6i">
      <div className="mx-auto max-w-5xl text-center" data-id="element-96" data-mp="3gh3s4gzgmag7">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-97" data-mp="32p5naics70pu">
          PILATES BEREIT™
        </p>
        <nav aria-label="Footer" data-id="element-98" data-mp="36nd4tff2k623">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-99" data-mp="3ufa6idot1hph">
            {links.map(link => <li key={link} data-id="element-100" data-mp="36muiocgf6ul">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-101" data-mp="3lem127dh8po7">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-102" data-mp="29ynmxp3fzdg4">
          © 2026 PILATES BEREIT™. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>;
}